import React from "react";
import { WATCH_BRANDS } from "../../lib/watchBrands";
import PhotoInput from "../../pages/sellWatch/PhotoInput";

const ALL_SERVICES = ["authenticate", "service", "polish", "ice", "protect"];
const LABELS = {
  authenticate: "Authenticate",
  service: "Service",
  polish: "Polish",
  ice: "Ice",
  protect: "Protect",
};

/**
 * Pure form body for RequestServiceModal — no auth/network concerns.
 * The parent handles submit + API call; this file is just inputs + toggles.
 */
export default function ServiceRequestForm({
  selected, onToggle,
  brand, setBrand,
  modelName, setModelName,
  ref, setRef,
  notes, setNotes,
  photo, setPhoto,
}) {
  const inputCls = "bg-transparent border border-white/20 focus:border-gold px-3 py-2 rounded text-sm";
  return (
    <>
      <div className="mb-3">
        <label className="text-[10px] uppercase tracking-widest text-white/60 block mb-1.5">Services requested</label>
        <div className="flex flex-wrap gap-1.5">
          {ALL_SERVICES.map((s) => {
            const on = selected.includes(s);
            return (
              <button
                type="button"
                key={s}
                onClick={() => onToggle(s)}
                data-testid={`sr-toggle-${s}`}
                className={`px-2.5 py-1 text-[10px] uppercase tracking-widest rounded-full border transition-colors ${on ? "bg-gold text-black border-gold" : "border-white/25 text-white/70 hover:border-gold hover:text-gold"}`}
              >
                {LABELS[s]}
              </button>
            );
          })}
        </div>
      </div>

      <div className="grid grid-cols-2 gap-2 mb-2">
        <input
          value={brand}
          onChange={(e) => setBrand(e.target.value)}
          placeholder="Brand"
          required
          list="rs-brand-list"
          autoComplete="off"
          data-testid="sr-brand"
          className={inputCls}
        />
        <datalist id="rs-brand-list">
          {WATCH_BRANDS.map((b) => <option key={b} value={b} />)}
        </datalist>
        <input
          value={modelName}
          onChange={(e) => setModelName(e.target.value)}
          placeholder="Model"
          required
          data-testid="sr-model"
          className={inputCls}
        />
      </div>
      <input
        value={ref}
        onChange={(e) => setRef(e.target.value)}
        placeholder="Reference number (optional)"
        data-testid="sr-ref"
        className={`w-full ${inputCls} mb-2`}
      />
      <textarea
        value={notes}
        onChange={(e) => setNotes(e.target.value)}
        rows={3}
        placeholder="Describe what you need (condition, symptoms, customization preferences, etc.)"
        data-testid="sr-notes"
        className={`w-full ${inputCls} mb-3 resize-none`}
      />

      {/* Photo of the piece — required so atelier admins can see the
          current condition before quoting. Compact variant keeps the
          modal comfortably above the fold. */}
      <div className="mb-3">
        <PhotoInput
          label="Photo of the watch"
          hint="A clear shot so our atelier can assess condition"
          value={photo}
          onChange={setPhoto}
          testId="sr-photo"
          compact
        />
      </div>
    </>
  );
}
